import classnames from 'classnames';
import Tooltip from 'shared/components/tooltip/tooltip';
import { sides } from 'shared/constants/popout';

import AccountInfo from '../account-info/account-info';

import styles from './account-button-with-tooltip.styl';


export default class AccountButtonWithTooltip extends React.Component {
  static propTypes = {
    className: React.PropTypes.string,
    logoutLabel: React.PropTypes.string,
    userEmail: React.PropTypes.string,
    tooltipSide: React.PropTypes.oneOf(_.values(sides)),

    onLogoutClick: React.PropTypes.func,
    onClick: React.PropTypes.func,
  };

  static defaultProps = {
    tooltipSide: sides.TOP,
  };

  render() {
    const { logoutLabel, userEmail, onLogoutClick, className, tooltipSide } = this.props;

    return (
      <Tooltip preventHideOnHover
               popoutSide={tooltipSide}
               iconName="avatar"
               className={classnames(styles['account-info-button'], className)}
               popoutClassName={styles.popout}
               popoutInnerClassName={styles['popout-inner']}
               popoutTriangleClassName={styles['popout-triangle']}>

        <AccountInfo logoutLabel={logoutLabel}
                     userEmail={userEmail}
                     onLogoutClick={onLogoutClick} />
      </Tooltip>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/account/account-button/account-info-button-with-tooltip/account-button-with-tooltip.js